export default {
  USER_ROLE: {
    USER: "user",
  },
  WS_EVENT_TYPES: {
    SMART_CONTRACT_WALLET_CREATED: "scw-created",
    SMART_CONTRACT_WALLET_BALANCE_UPDATED: "scw-balance-updated",
    RELAY_TRANSACTION_FINISHED: "relay-transaction-finished",
    RELAY_TRANSACTION_STARTED: "relay-transaction-started",
    KYBERDAO_TX_CONFIRMED: "kyberdao-tx-confirmed",
    KYBERDAO_MASTER_CLAIMED_REWARDS: "kyberdao-pool-master-claimed-reward",
    ACCOUNT_BALANCE_CHANGED: "account-balance-changed",
    SMART_CONTRACT_TX_CONFIRMED: "smartcontract-tx-confirmed",
    TENDERMINT_TX_CONFIRMED: "tendermint-staking-tx-confirmed",
    ANNOUCEMENT: "new-notification",
    ETH_STAKING_FINISHED: "eth-staking-tx-finished",
    NONETH_STAKING_FINISHED: "noneth-staking-tx-finished",
  },
  TX_TYPES: {
    KYBER: "kyberdao",
    TENDERMINT: "tendermint_staking",
    VAULT: "uvault",
    ETH_STAKING: "eth_staking",
    NONETH_STAKING: "noneth_staking",
  },
  TX_TYPE_TO_NOTI_KEY: {
    kyberdao: "kyberdao",
    uvault: "uvault",
    tendermint_staking: "tendermint",
    eth_staking: "eth",
    noneth_staking: "noneth",
  },
  EVENT_TYPE_TO_TX_TYPE: {
    "kyberdao-tx-confirmed": "kyberdao",
    "smartcontract-tx-confirmed": "uvault",
    "tendermint-staking-tx-confirmed": "tendermint_staking",
    "eth-staking-tx-finished": "eth_staking",
    "noneth-staking-tx-finished": "noneth_staking",
  },
  VAULT_MAP: {
    safe: "Stash",
    stash: "Stash",
    growth: "Growth",
    safeV2: "Stash V2",
  },
  TX_ERROR: {
    CONNECT_TIMEOUT: 100502,
    SIGN_TIMEOUT: 100503,
    BROADCAST_TIMEOUT: 100504,
  },
  SKALE_TX_STATE: {
    PROPOSED: "PROPOSED",
    ACCEPTED: "ACCEPTED",
    CANCELED: "CANCELED",
    REJECTED: "REJECTED",
    DELEGATED: "DELEGATED",
    UNDELEGATION_REQUESTED: "UNDELEGATION_REQUESTED",
    COMPLETED: "COMPLETED",
  },
};
